// extracted by mini-css-extract-plugin
module.exports = {"title":"FormHeading_title_3LpO2","badge":"FormHeading_badge_2ajtR","text":"FormHeading_text_2lUqC","line":"FormHeading_line_3gfB6"};
    if(module.hot) {
      // 1789136763113
      var cssReload = require("/drone/src/node_modules/@vue/cli-service/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"hmr":true,"publicPath":"../","locals":true});
      module.hot.dispose(cssReload);
      
    }
  